export const getCategoryColor = (category: string | undefined) => {
  switch (category) {
    case '농업기반시설':
      return 'bg-green-100 text-green-800';
    case '상수도':
      return 'bg-blue-100 text-blue-800';
    case '기타':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
